export const NATURAL_LANGUAGE_SEARCH_DEBOUNCE_MS = 500
export const NATURAL_LANGUAGE_SEARCH_AI_GLOW_EFFECT_TIME_OUT_MS = 4000
